import { RootState } from "@/store/dtm";
import { addressType } from "@/types/addressType";
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface propertyAddressState {
    address: addressType
}

const initialState: propertyAddressState = {
    address: {
        id: 0,
        streetNumber: "",
        streetType: "",
        streetDirection: "",
        unitType: "",
        unitNumber: "",
        streetName: "",
        city: "",
        province: "",
        postalCode: "",
        country: "Canada",
    }
}


export const propertyAddressSlice = createSlice({
    name: "propertyAddress",
    initialState,
    reducers: {
        setPAStreetNumber: (state, action: PayloadAction<string>) => {
            const streetNumber = action.payload;
            state.address.streetNumber = streetNumber;
        },
        setPAUnitNumber: (state, action: PayloadAction<string>) => {
            const unitNumber = action.payload;
            state.address.unitNumber = unitNumber;
        },
        setPAUnitType: (state, action: PayloadAction<string>) => {
            const unitType = action.payload;
            state.address.unitType = unitType;
        },
        setPAStreetName: (state, action: PayloadAction<string>) => {
            const streetName = action.payload;
            state.address.streetName = streetName;
        },
        setPAStreetType: (state, action: PayloadAction<string>) => {
            const streetType = action.payload;
            state.address.streetType = streetType;
        },
        setPAStreetDirection: (state, action: PayloadAction<string>) => {
            const streetDirection = action.payload;
            state.address.streetDirection = streetDirection;
        },
        setPACity: (state, action: PayloadAction<string>) => {
            const city = action.payload;
            state.address.city = city;
        },
        setPAProvince: (state, action: PayloadAction<string>) => {
            const province = action.payload;
            state.address.province = province;
        },
        setPAPostalCode: (state, action: PayloadAction<string>) => {
            const postalCode = action.payload;
            state.address.postalCode = postalCode;
        },
        setPACountry: (state, action: PayloadAction<string>) => {
            const country = action.payload;
            state.address.country = country;
        },

        clearPropertyAddressState: (state) => {
            state.address.id = 0;
            state.address.streetNumber = "";
            state.address.streetName = "";
            state.address.streetType = "";
            state.address.streetDirection = "";
            state.address.unitNumber = "";
            state.address.unitType = "";
            state.address.city = "";
            state.address.province = "";
            state.address.postalCode = "";
            state.address.country = "Canada";
        }
    }
});

export const { setPAStreetNumber, setPAUnitNumber, setPAUnitType, setPAStreetName, setPAStreetType, setPAStreetDirection, 
    setPACity, setPAProvince, setPAPostalCode, setPACountry, clearPropertyAddressState } = propertyAddressSlice.actions

export default propertyAddressSlice.reducer

export const selectPropertyAddress = (state: RootState) => state.propertyAddress;